var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "personal-container"
  }, [_c("div", {
    staticClass: "personal-content general-layout"
  }, [_c("div", {
    staticClass: "left-nav"
  }, [_c("ul", _vm._l(_vm.tablist, function (item, index) {
    return _c("li", {
      key: index,
      style: {
        color: _vm.activeKey === index ? "#3870FF" : ""
      },
      on: {
        click: function ($event) {
          return _vm.tabChange(index);
        }
      }
    }, [_vm._v(_vm._s(item.value))]);
  }), 0)]), _c("div", {
    staticClass: "right-content"
  }, [_vm.activeKey === 0 ? _c("div", {
    staticClass: "personal-table"
  }, [_c("TableData", {
    attrs: {
      tabletype: "personal",
      data: _vm.personaldata
    }
  })], 1) : _c("div", {
    staticClass: "order-table"
  }, [_c("v-ordertable", {
    attrs: {
      productdata: _vm.personaldata,
      total: _vm.total,
      loading: _vm.loading
    }
  })], 1)])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };